import {UIService} from "../UIService";
import {ProductDataService} from "../../services/productDataService";
import {ProductDataStore} from "../../stores/productDataStore";
import {GlazingService} from "./glazingService";
import {AppStateService} from "../../services/appStateService";
import {EventService} from "../../services/eventService";
import {PriceFormatter} from "../../services/priceFormatter";
import {ErrorReportingService} from "../../services/errorReportingService";

export class GlazingUIService {
    private uiService: UIService;
    private productDataService: ProductDataService;
    private productDataStore: ProductDataStore;
    private glazingService: GlazingService;
    private appStateService: AppStateService;
    private priceFormatter: PriceFormatter;
    private eventService: EventService;
    private errorReportingService: ErrorReportingService;

    constructor() {
        this.uiService = new UIService();
        this.productDataService = new ProductDataService();
        this.productDataStore = new ProductDataStore();
        this.glazingService = new GlazingService();
        this.appStateService = new AppStateService();
        this.eventService = new EventService();
        this.priceFormatter = new PriceFormatter();
        this.errorReportingService = new ErrorReportingService();

        this.populatePreview();
    }

    private populatePreview()
    {
        const selectedInsideGlassElements = this.uiService.getElementByActionName('selected-insideGlass');
        const selectedOutsideGlassElements = this.uiService.getElementByActionName('selected-outsideGlass');
        const selectedOrnamentElements = this.uiService.getElementByActionName('selected-ornament');

        const glass = this.productDataStore.getAvailableOptionsByName('glass');
        const ornaments = this.productDataStore.getAvailableOptionsByName('ornament');

        const selectedInsideGlassId = this.productDataStore.getSelectedOptionIdByName('insideGlass');
        const selectedOutsideGlassId = this.productDataStore.getSelectedOptionIdByName('outsideGlass');
        const selectedOrnamentId = this.productDataStore.getSelectedOptionIdByName('ornament');

        selectedInsideGlassElements.forEach((element) => {
            this.uiService.removeHtmlInElement(element);
        });
        selectedOutsideGlassElements.forEach((element) => {
            this.uiService.removeHtmlInElement(element);
        });
        selectedOrnamentElements.forEach((element) => {
            this.uiService.removeHtmlInElement(element);
        });

        glass.forEach((singleGlass) => {
            if (selectedInsideGlassId === singleGlass.id) {
                const element = document.createElement('p');
                element.appendChild(
                        document.createTextNode(
                            singleGlass.attributes.name
                        )
                    );

                this.uiService.addHtmlInElement(
                    this.uiService.getElementByAttribute(
                        'nf-action',
                        'selected-insideGlass'
                    ),
                    element.innerHTML
                );
            }
            if (selectedOutsideGlassId === singleGlass.id) {
                const element = document.createElement('p');
                element.appendChild(
                        document.createTextNode(
                            singleGlass.attributes.name
                        )
                    );

                this.uiService.addHtmlInElement(
                    this.uiService.getElementByAttribute(
                        'nf-action',
                        'selected-outsideGlass'
                    ),
                    element.innerHTML
                );
            }
        });
        ornaments.forEach((ornament) => {
            if (selectedOrnamentId === ornament.id) {
                const element = document.createElement('p');
                element.appendChild(
                        document.createTextNode(
                            ornament.attributes.name
                        )
                    );

                this.uiService.addHtmlInElement(
                    this.uiService.getElementByAttribute(
                        'nf-action',
                        'selected-ornament'
                    ),
                    element.innerHTML
                );
                this.uiService.replaceTextInElement(
                    this.uiService.getElementByAttribute(
                        'nf-value-key',
                        'selectedOrnamentName'
                    ),
                    ornament.attributes.name
                );
            }
        });
    }

    public initializeGlazingComponent()
    {
        const glass = this.productDataStore.getAvailableOptionsByName('glass');
        const ornaments = this.productDataStore.getAvailableOptionsByName('ornament');

        const insideGlass = glass.filter(glass => glass.attributes.canBeInside === true);
        const outsideGlass = glass.filter(glass => glass.attributes.canBeOutside === true);

        insideGlass.forEach((glass) => {
            const option = this.createInsideGlassOption(glass);
            if (glass.id === this.productDataStore.getSelectedOptionIdByName('insideGlass')) {
                this.uiService.setSelectedOption(option);
            }

            option.addEventListener('click', (event: any) => {
                if (this.uiService.isOptionDisabled(event.currentTarget)) {
                    return;
                }

                this.uiService.resetSelectionsByPartName('insideGlass');
                this.uiService.setSelectedOption(event.currentTarget);
                this.productDataService.updateSelectedOptionByName('insideGlass', glass.id, true);
                this.refreshInsideGlassOptions();
                this.refreshOrnamentOptions();
                this.refreshOutsideGlassOptions();
                this.populatePreview();
            });
        });

        outsideGlass.forEach((glass) => {
            const option = this.createOutsideGlassOption(glass);
            if (glass.id === this.productDataStore.getSelectedOptionIdByName('outsideGlass')) {
                this.uiService.setSelectedOption(option);
            }

            option.addEventListener('click', (event: any) => {
                if (this.uiService.isOptionDisabled(event.currentTarget)) {
                    return;
                }

                this.uiService.resetSelectionsByPartName('outsideGlass');
                this.uiService.setSelectedOption(event.currentTarget);
                this.productDataService.updateSelectedOptionByName('outsideGlass', glass.id, true);
                this.refreshOutsideGlassOptions();
                this.populatePreview();
            });
        });

        if (!this.productDataService.isRoofWindow()) {
            ornaments.forEach((ornament) => {
                const option = this.createOrnamentOption(ornament);
                if (ornament.id === this.productDataStore.getSelectedOptionIdByName('ornament')) {
                    this.uiService.setSelectedOption(option);
                }

                if (this.glazingService.disableOrnamentOption()) {
                    this.uiService.disableOption(option);
                }

                option.addEventListener('click', (event: any) => {
                    if (this.uiService.isOptionDisabled(event.currentTarget)) {
                        return;
                    }

                    this.uiService.resetSelectionsByPartName('ornament');
                    this.uiService.setSelectedOption(event.currentTarget);
                    this.productDataService.updateSelectedOptionByName('ornament', ornament.id, true);
                    this.refreshInsideGlassOptions();
                    this.refreshOrnamentOptions();
                    this.populatePreview();
                });
            });
        }

        if (
            !this.productDataStore.getProductInfoAttributeByName('enableOrnamentChanging') ||
            this.productDataService.isRoofWindow()
        ) {
            this.appStateService.setAppSettingTemplateFlag('glazing', 'ornamentsContainer', false);
            this.uiService.refreshElementsInModule('glazing');
        }

        // const resetButton = this.uiService.getResetButtonByModule('glazing');
        // resetButton.addEventListener('click', this.glazingService.resetSelectedOptions.bind(this));

        this.initializeInformationModal();
        this.setPartDiscountImage();
        this.glazingService.refreshComponentTemplate();

        this.eventService.getTarget().addEventListener('sizeChange', (data) => {
            this.refreshPrices();
        });
    }

    private initializeInformationModal()
    {
        const closeButton = document
            .querySelector('.configuratorPanel[nf-component-name="glazing"]')
            .querySelector(`[nf-action="glazingDetailsModalClose"]`);

        closeButton.addEventListener('click', () => {
            this.appStateService.setAppSettingTemplateFlag('glazing', 'glazingDetailsModal', false);
            this.uiService.refreshElementsInModule('glazing');
        });
    }

    private refreshInsideGlassOptions()
    {
        const insideGlass = this.uiService.getElementsByPartName('insideGlass');

        insideGlass.forEach((glass) => {
            const glassId = glass.getAttribute('nf-option-id');

            if (this.glazingService.disableInsideGlassOption(glassId)) {
                this.uiService.disableOption(glass);
            } else {
                this.uiService.enableOption(glass);
            }
        });

        this.glazingService.refreshComponentTemplate();
    }

    private refreshOutsideGlassOptions()
    {
        const outsideGlass = this.uiService.getElementsByPartName('outsideGlass');

        outsideGlass.forEach((glass) => {
            const glassId = glass.getAttribute('nf-option-id');

            if (this.glazingService.disableOutsideGlassOption(glassId)) {
                this.uiService.disableOption(glass);
            } else {
                this.uiService.enableOption(glass);
            }
        });

        this.glazingService.refreshComponentTemplate();
    }

    private refreshOrnamentOptions()
    {
        const ornaments = this.uiService.getElementsByPartName('ornament');

        ornaments.forEach((ornament) => {
            if (this.glazingService.disableOrnamentOption()) {
                this.uiService.disableOption(ornament);
            } else {
                this.uiService.enableOption(ornament);
            }
        });

        this.glazingService.refreshComponentTemplate();
    }

    private openModal(glass)
    {
        this.uiService.setAttributeToElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'modalImg',
                document.querySelector(
                    '.configuratorPanel[nf-component-name="glazing"]'
                ),
            ),
            'src',
            glass.attributes.imgSrc
        );
        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'modalTitle',
                document.querySelector(
                    '.configuratorPanel[nf-component-name="glazing"]'
                ),
            ),
            glass.attributes.name
        );
        this.uiService.replaceTextInElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'modalContent',
                document.querySelector(
                    '.configuratorPanel[nf-component-name="glazing"]'
                ),
            ),
            glass.attributes.modalContent
        );
        this.appStateService.setAppSettingTemplateFlag('glazing', 'glazingDetailsModal', true);
        this.uiService.refreshElementsInModule('glazing');
    }

    private createInsideGlassOption(insideGlass)
    {
        const option = this.uiService.createConfiguratorOption('insideGlass');
        const readMoreButton = option.querySelector(`[nf-action="openGlassInfoModal"]`);

        this.uiService.setAttributeToElement(
            option,
            'nf-option-id',
            insideGlass.id
        );

        this.uiService.addTextInElement(
            option.querySelector('[nf-value-key="name"]'),
            insideGlass.attributes.name
        );

        if (this.hasFixedGlassPrice()) {
            this.uiService.addTextInElement(
                option.querySelector('[nf-value-key="price"]'),
                this.priceFormatter.getPriceWithCurrency(insideGlass.attributes.priceFixedAfterDiscount)
            );
        } else {
            const price = this.glazingService.getGlazingPrice(insideGlass.attributes.pricePerM2AfterDiscount);
            this.uiService.addTextInElement(
                option.querySelector('[nf-value-key="price"]'),
                price);
        }

        if (readMoreButton !== null) {
            readMoreButton.addEventListener('click', (event: any) => {
                this.openModal(insideGlass);

                event.preventDefault();
                event.stopPropagation();

                return false;
            });
        }

        return option;
    }

    private createOutsideGlassOption(outsideGlass)
    {
        const option = this.uiService.createConfiguratorOption('outsideGlass');
        const readMoreButton = option.querySelector(`[nf-action="openGlassInfoModal"]`);

        this.uiService.setAttributeToElement(
            option,
            'nf-option-id',
            outsideGlass.id
        );

        this.uiService.addTextInElement(
            option.querySelector('[nf-value-key="name"]'),
            outsideGlass.attributes.name
        );

        if (this.hasFixedGlassPrice()) {
            this.uiService.addTextInElement(
                option.querySelector('[nf-value-key="price"]'),
                this.priceFormatter.getPriceWithCurrency(outsideGlass.attributes.priceFixedAfterDiscount)
            );
        } else {
            const price = this.glazingService.getGlazingPrice(outsideGlass.attributes.pricePerM2AfterDiscount);
            this.uiService.addTextInElement(
                option.querySelector('[nf-value-key="price"]'),
                price
            );
        }

        if (readMoreButton !== null) {
            readMoreButton.addEventListener('click', (event: any) => {
                this.openModal(outsideGlass);

                event.preventDefault();
                event.stopPropagation();

                return false;
            });
        }

        return option;
    }

    private createOrnamentOption(ornament)
    {
        const option = this.uiService.createConfiguratorOption('ornamentGlass');

        this.uiService.setAttributeToElement(
            option,
            'nf-option-id',
            ornament.id
        );

        this.uiService.setAttributeToElement(
            option.querySelector('[nf-value-key="icon"]'),
            'src',
            ornament.attributes.imgSrc);

        this.uiService.addTextInElement(
            option.querySelector('[nf-value-key="name"]'),
            ornament.attributes.name);

        if (this.hasFixedGlassPrice()) {
            this.uiService.addTextInElement(
                option.querySelector('[nf-value-key="price"]'),
                this.priceFormatter.getPriceWithCurrency(ornament.attributes.priceFixedAfterDiscount)
            );
        } else {
            const price = this.glazingService.getGlazingPrice(ornament.attributes.pricePerM2AfterDiscount);
            this.uiService.addTextInElement(
                option.querySelector('[nf-value-key="price"]'),
                price
            );
        }

        return option;
    }

    private refreshPrices()
    {
        const insideGlass = this.uiService.getElementsByPartName('insideGlass');
        const outsideGlass = this.uiService.getElementsByPartName('outsideGlass');
        const ornament = this.uiService.getElementsByPartName('ornament');

        insideGlass.forEach((glass) => {
            const glassId: any = glass.getAttribute('nf-option-id');
            const insideGlass = this.productDataStore.getAvailableOptionByNameAndId('glass', glassId);

            if (this.hasFixedGlassPrice()) {
                return;
            } else {
                const price = this.glazingService.getGlazingPrice(insideGlass.attributes.pricePerM2AfterDiscount);
                const priceElement = glass.querySelector('[nf-value-key="price"]');

                if (priceElement !== null) {
                    this.uiService.replaceTextInElement(
                        priceElement,
                        price
                    );
                } else {
                    this.errorReportingService.display(`Price element on inside glass #${glassId} is missing.`);
                }
            }
        });

        outsideGlass.forEach((glass) => {
            const glassId: any = glass.getAttribute('nf-option-id');
            const outsideGlass = this.productDataStore.getAvailableOptionByNameAndId('glass', glassId);

            if (this.hasFixedGlassPrice()) {
                return;
            } else {
                const price = this.glazingService.getGlazingPrice(outsideGlass.attributes.pricePerM2AfterDiscount);
                const priceElement = glass.querySelector('[nf-value-key="price"]');

                if (priceElement !== null) {
                    this.uiService.replaceTextInElement(
                        priceElement,
                        price
                    );
                } else {
                    this.errorReportingService.display(`Price element on outside glass #${glassId} is missing.`);
                }
            }
        });

        ornament.forEach((ornament) => {
            const ornamentId: any = ornament.getAttribute('nf-option-id');
            const ornamentGlass = this.productDataStore.getAvailableOptionByNameAndId('ornament', ornamentId);

            if (this.hasFixedGlassPrice()) {
                return;
            } else {
                const price = this.glazingService.getGlazingPrice(ornamentGlass.attributes.pricePerM2AfterDiscount);
                const priceElement = ornament.querySelector('[nf-value-key="price"]');

                if (priceElement !== null) {
                    this.uiService.replaceTextInElement(
                        priceElement,
                        price
                    );
                } else {
                    this.errorReportingService.display(`Price element on outside glass #${ornamentId} is missing.`);
                }
            }
        });
    }

    private hasFixedGlassPrice()
    {
        return this.productDataService.isEntranceDoor() && !this.productDataStore.getProductInfoAttributeByName('productIsFullGlass');
    }

    private setPartDiscountImage()
    {
        const partDiscountImageUrl = this.productDataService.getPartDiscountBannerByModule('glass');

        if (partDiscountImageUrl) {
            this.uiService.setAttributeToElement(
                this.uiService.getElementByAttribute('nf-template-flag', 'glazingPartDiscountBanner'),
                'src',
                partDiscountImageUrl
            );

            this.appStateService.setAppSettingTemplateFlag('glazing', 'glazingPartDiscountBanner', true);
            this.uiService.refreshElementsInModule('glazing');
        }
    }

}
